export const LANDING_IMAGES = {
  hero: "https://images.unsplash.com/photo-1587582423116-ec07293f0395?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  plumbers:
    "https://images.unsplash.com/photo-1749532125405-70950966b0e5?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxwbHVtYmluZyUyMHBpcGUlMjByZXBhaXJ8ZW58MXx8fHwxNzcyNTY1NjkxfDA&ixlib=rb-4.1.0&q=80&w=1080",
  electricians:
    "https://images.unsplash.com/photo-1682345262055-8f95f3c513ea?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxlbGVjdHJpY2lhbiUyMHdvcmtpbmclMjBwYW5lbHxlbnwxfHx8fDE3NzI1OTE0NjV8MA&ixlib=rb-4.1.0&q=80&w=1080",
  hvac: "https://images.unsplash.com/photo-1737012197886-7d5a52ded45b?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxjYXJwZW50ZXIlMjB3b29kd29ya2luZyUyMHRvb2xzfGVufDF8fHx8MTc3MjYyMDg2MHww&ixlib=rb-4.1.0&q=80&w=1080",
  general:
    "https://images.unsplash.com/photo-1513467535987-fd81bc7d62f8?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjByZW5vdmF0ZWQlMjBob21lJTIwaW50ZXJpb3J8ZW58MXx8fHwxNzcyNjc1MTEwfDA&ixlib=rb-4.1.0&q=80&w=1080",
  landscapers:
    "https://images.unsplash.com/photo-1689728318937-17d24bc0a65c?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxsYW5kc2NhcGluZyUyMHByb2Zlc3Npb25hbHxlbnwxfHx8fDE3NzI2NzU1ODh8MA&ixlib=rb-4.1.0&q=80&w=1080",
  painters:
    "https://images.unsplash.com/photo-1652829069834-2c05031199c5?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxwYWludGVyJTIwcGFpbnRpbmclMjB3YWxsfGVufDF8fHx8MTc3MjY2MzM3N3ww&ixlib=rb-4.1.0&q=80&w=1080",
  whyToolkit:
    "https://images.unsplash.com/photo-1669170936278-010c9c8eb680?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxjb25zdHJ1Y3Rpb24lMjBzb2Z0d2FyZXxlbnwxfHx8fDE3NzI2NzYwODB8MA&ixlib=rb-4.1.0&q=80&w=1080",
  productWebsite:
    "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=1600",
  productPhotos:
    "https://images.unsplash.com/photo-1504307651254-35680f356dfd?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=1600",
  productCredentials:
    "https://images.unsplash.com/photo-1586281380349-632531db7ed4?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=1600",
} as const;

const LANDING_HERO_STOCK_KEYS = [
  "plumbers",
  "electricians",
  "hvac",
  "landscapers",
  "painters",
] as const;

type LandingHeroStockKey = (typeof LANDING_HERO_STOCK_KEYS)[number];

const LANDING_HERO_TRADE_KEYWORDS: Record<LandingHeroStockKey, string[]> = {
  plumbers: ["plumb", "pipe", "drain"],
  electricians: ["electric", "wiring", "electrical"],
  hvac: ["hvac", "heating", "cooling", "air conditioning", "air-conditioning"],
  landscapers: ["landscap", "lawn", "yard", "outdoor"],
  painters: ["paint", "painter", "painting"],
};

/** Stock hero for contractor sites: match trade to landing imagery, else `general`. */
export function resolveStockHeroImageUrl(tradeDisplayName: string): string {
  const normalized = tradeDisplayName.toLowerCase();
  for (const key of LANDING_HERO_STOCK_KEYS) {
    const keywords = LANDING_HERO_TRADE_KEYWORDS[key];
    if (keywords.some((kw) => normalized.includes(kw))) {
      return LANDING_IMAGES[key];
    }
  }
  return LANDING_IMAGES.general;
}
